var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mobile-filter" }, [
    _c(
      "button",
      {
        staticClass: "mobile-filter-btn",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.toggle.apply(null, arguments)
          },
        },
      },
      [_vm._v("Filtrera och sortera här")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.opened,
            expression: "opened",
          },
        ],
        staticClass: "mobile-filter__wrapper",
      },
      [
        _c("header", { staticClass: "mobile-filter__header" }, [
          _c("h6", { staticClass: "mobile-filter__heading" }, [
            _vm._v("Filtrera och sortera här"),
          ]),
          _vm._v(" "),
          _vm.hasSubCategories || _vm.taxonomies.length
            ? _c(
                "button",
                {
                  staticClass: "mobile-filter__clear",
                  class: {
                    "mobile-filter__clear--disabled":
                      _vm.selectedCategories.length === 0 &&
                      _vm.selectedTaxonomyIds.length === 0,
                  },
                  on: { click: _vm.clearAll },
                },
                [_vm._v("\n        Rensa alla val\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "mobile-filter__close", on: { click: _vm.toggle } },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "#F7AA10",
                  },
                },
                [
                  _c("path", { attrs: { fill: "none", d: "M0 0h24v24H0z" } }),
                  _c("path", {
                    attrs: {
                      d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mobile-filter__content" },
          [
            _c("sort"),
            _vm._v(" "),
            _c("categories", {
              attrs: {
                categories: _vm.categories,
                isShopPage: _vm.isShopPage,
                selectedCategories: _vm.selectedCategories,
                hasSubCategories: _vm.hasSubCategories,
                category: _vm.category,
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.taxonomies, function (taxonomy) {
              return _c("taxonomy", {
                key: taxonomy.name,
                attrs: { taxonomy: taxonomy },
              })
            }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/MobileFilter.vue